import { Form } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import { useUploader } from 'services/upload/upload';
import { useNotification } from 'hooks/useNotification';
import { useAppProviderStore } from 'store/appProviderCopyStore';
import { useMemo, useState } from 'react';
import { Grid } from '@mui/material';
import { ImageUploadButton } from './ImageUploadButton/ImageUploadButton';

export const ThumbUploadField = ({
  watch,
  control,
  variant,
  register,
  getValues,
  viewFields,
}) => {
  const { uploadThumbFile } = useUploader({ variant });
  const { isLoading, setIsLoading } = useAppProviderStore();
  const { openErrorNotification } = useNotification();
  const [canUpload, setCanUpload] = useState(true);

  const thumbnailsImages = watch('thumbnails');

  const thumbnailsView = useMemo(() => {
    const squarelThumb = thumbnailsImages?.find(i => i.type === 'SQUARE');
    const verticalThumb = thumbnailsImages?.find(i => i.type === 'VERTICAL');

    return {
      square: squarelThumb?.tempURL || squarelThumb?.url || null,
      vertical: verticalThumb?.tempURL || verticalThumb?.url || null,
    };
  }, [thumbnailsImages]);

  const onChangeThumbnail = async ({ newValue, type, value, onChange }) => {
    setIsLoading(true);
    setCanUpload(false);

    const file = newValue?.target?.files?.[0];

    try {
      const id = getValues('id');
      const version = getValues('version');

      const response = await uploadThumbFile({
        id,
        file,
        type,
        version,
      });

      const updatedThumbs =
        value?.map(thumb => {
          if (thumb.type === type) {
            return response;
          }

          return thumb;
        }) || [];

      if (!updatedThumbs.some(i => i.type === type)) {
        updatedThumbs.push(response);
      }

      onChange(updatedThumbs);
      openErrorNotification({
        message: `Imagem incluida com sucesso: ${file?.name}`,
        title: 'Sucesso',
        type: 'success'
      });
    } catch (error) {
      openErrorNotification({
        message: `Erro ao incluir a imagem: ${file?.name}`,
        title: 'Ops! Algo deu errado...',
      });
    } finally {
      setIsLoading(false);
      setCanUpload(true);
    }
  };

  return (
    <Form.Group
      className="mb-3"
      controlId="formName"
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}>
      <Controller
        name="thumbnails"
        control={control}
        render={({ field: { onChange, value } }) => {
          return (
            <Grid item container xs={12}>
              <Grid item xs={6} alignItems="center" justifyContent="center">
                <ImageUploadButton
                  value={value}
                  image={thumbnailsView.square}
                  register={register}
                  disabled={!canUpload || viewFields}
                  loading={isLoading}
                  variant="SQUARE"
                  onChange={newValue => {
                    onChangeThumbnail({
                      newValue,
                      type: 'SQUARE',
                      value,
                      onChange,
                    });
                  }}
                />
              </Grid>
              <Grid item xs={6} alignItems="center" justifyContent="center">
                <ImageUploadButton
                  value={value}
                  image={thumbnailsView.vertical}
                  register={register}
                  disabled={!canUpload || viewFields}
                  loading={isLoading}
                  variant="VERTICAL"
                  onChange={newValue => {
                    onChangeThumbnail({
                      newValue,
                      type: 'VERTICAL',
                      value,
                      onChange,
                    });
                  }}
                />
              </Grid>
            </Grid>
          );
        }}
      />
    </Form.Group>
  );
};
